import {
  OpeningStatement,
  Website,
  SchoolType,
  UndergraduateEnrollment,
  StudentFacultyRatio,
  CampusSurroundings,
  GPA,
  ContactInformation,
  TestScores,
} from './overview';

import {
  FeesComponent,
  DeadlinesComponent,
  AcceptanceRateComponent,
  ImportantPoliciesComponent,
  RecommendedCoursesComponent,
  ApplicationFactorsComponent,
  ApplicationRequirementsComponent,
} from './admissions';

import {
  GraduationRate4,
  GraduationRate6,
  StudentRetention,
  StudyOptions,
  TopAreasOfStudy,
} from './studies';

import {
  SchoolSize,
  NearestCity,
  Ethnicity,
  AgeData,
  GreekLife,
  HousingData,
  Services,
  Organizations,
  ComputingResources,
  Athletics,
} from './studentLife';

import { AvgAmountOfAid, AvgNetPrices, PercentageReceivingAid } from './costs';
import {
  TransferAdmissionsContact,
  TransferApplicationRequirements,
  TransferFinancialAidInfoWebsite,
  TransferSupportWebsite,
  TransferWebsite,
  TransferOverview,
  TransferCreditCap,
  TransferCreditsNotAccepted,
  TransferAcademicResidency,
  TransferUndergraduateStudents,
  TransferEightYearGraduationRate,
  TransferScholarshipAvailability,
  TransferCreditTransferInfoWebsite,
  TransferArticulationAgreements,
  DualAdmissionsPrograms,
  TransferEnrollmentTerms,
  TransferCollegeSystems,
} from './transferInfo';
import TransferCreditPolicies from './transferInfo/transferCreditPolicies';

const menuItems = [
  {
    type: 'overview',
    items: [
      {
        type: 'openingStatement',
        render: OpeningStatement,
      },
      {
        type: 'website',
        render: Website,
      },
      {
        type: 'schoolType',
        render: SchoolType,
      },
      {
        type: 'undergraduateEnrollment',
        render: UndergraduateEnrollment,
      },
      {
        type: 'studentFacultyRatio',
        render: StudentFacultyRatio,
      },
      {
        type: 'campusSurroundings',
        render: CampusSurroundings,
      },
      {
        type: 'testScores',
        render: TestScores,
      },
      {
        type: 'gpa',
        render: GPA,
      },
      {
        type: 'contactInformation',
        render: ContactInformation,
      },
    ],
  },
  {
    type: 'studies',
    items: [
      {
        type: 'studentFacultyRatio',
        render: StudentFacultyRatio,
      },
      {
        type: 'studentRetention',
        render: StudentRetention,
      },
      {
        type: 'graduationRate4',
        render: GraduationRate4,
      },
      {
        type: 'graduationRate6',
        render: GraduationRate6,
      },
      {
        type: 'topAreasOfStudy',
        render: TopAreasOfStudy,
      },
      {
        type: 'studyOptions',
        render: StudyOptions,
      },
    ],
  },
  {
    type: 'studentLife',
    items: [
      {
        type: 'schoolSize',
        render: SchoolSize,
      },
      {
        type: 'nearestCity',
        render: NearestCity,
      },
      {
        type: 'ethnicity',
        render: Ethnicity,
      },
      {
        type: 'genderData',
        render: SchoolSize,
      },
      {
        type: 'ageData',
        render: AgeData,
      },
      {
        type: 'housingData',
        render: HousingData,
      },
      {
        type: 'greekLife',
        render: GreekLife,
      },
      {
        type: 'services',
        render: Services,
      },
      {
        type: 'computingResources',
        render: ComputingResources,
      },
      {
        type: 'organizations',
        render: Organizations,
      },
      {
        type: 'athletics',
        render: Athletics,
      },
    ],
  },
  {
    type: 'admissions',
    items: [
      {
        type: 'acceptanceRate',
        render: AcceptanceRateComponent,
      },
      {
        type: 'importantPolicies',
        render: ImportantPoliciesComponent,
      },
      {
        type: 'deadlines',
        render: DeadlinesComponent,
      },
      {
        type: 'fees',
        render: FeesComponent,
      },
      {
        type: 'applicationRequirements',
        render: ApplicationRequirementsComponent,
      },
      {
        type: 'recommendedCourses',
        render: RecommendedCoursesComponent,
      },
      {
        type: 'applicationFactors',
        render: ApplicationFactorsComponent,
      },
    ],
  },
  {
    type: 'costs',
    items: [
      {
        type: 'averageNetPrices',
        render: AvgNetPrices,
      },
      {
        type: 'receivingAid',
        render: PercentageReceivingAid,
      },
      {
        type: 'averageAmountOfAid',
        render: AvgAmountOfAid,
      },
    ],
  },
  {
    type: 'transferInfo',
    items: [
      {
        type: 'transferOverview',
        render: TransferOverview,
      },
      {
        type: 'transferUndergraduateStudents',
        render: TransferUndergraduateStudents,
      },
      {
        type: 'transferEightYearGradRate',
        render: TransferEightYearGraduationRate,
      },
      {
        type: 'transferWebsite',
        render: TransferWebsite,
      },
      {
        type: 'supportWebsite',
        render: TransferSupportWebsite,
      },
      {
        type: 'creditTransferInfoWebsite',
        render: TransferCreditTransferInfoWebsite,
      },
      {
        type: 'financialAidInfoWebsite',
        render: TransferFinancialAidInfoWebsite,
      },
      {
        type: 'transferAdmissionsContact',
        render: TransferAdmissionsContact,
      },
      {
        type: 'transferApplicationRequirements',
        render: TransferApplicationRequirements,
      },
      {
        type: 'transferCreditPolicies',
        render: TransferCreditPolicies,
      },
      {
        type: 'transferArticulationAgreements',
        render: TransferArticulationAgreements,
      },
      {
        type: 'dualAdmissionsPrograms',
        render: DualAdmissionsPrograms,
      },
      {
        type: 'collegeSystems',
        render: TransferCollegeSystems,
      },
      {
        type: 'transferAcademicResidency',
        render: TransferAcademicResidency,
      },
      {
        type: 'transferCreditCap',
        render: TransferCreditCap,
      },
      {
        type: 'transferCreditsNotAccepted',
        render: TransferCreditsNotAccepted,
      },
      {
        type: 'transferScholarshipAvailability',
        render: TransferScholarshipAvailability,
      },
      {
        type: 'transferEnrollmentTerms',
        render: TransferEnrollmentTerms,
      },
    ],
  },
];

export default menuItems;
